import * as moment from 'moment';
import {Moment} from 'moment';
import {LocalLocationType} from '../../local-loads/shared/local-location-type';
import {CmblAddress} from '../../shared/cmbl-address.model';
import {OverdueType} from './overdue-type';

export class OverdueDelivery {

  public deliveryNumber: string;
  public deliveryPriority: number;
  public overdue: string;
  public type: OverdueType;
  public carrier: OverdueCarrier;
  public origin: OverdueDeliveryLocation;
  public destination: OverdueDeliveryLocation;
  public deliveryDate: Moment;
  public deliveryOriginalDate: Moment;
  public deliveryDeadline: Moment;
  public deliveryGiDate: Moment;
  public picked: boolean;
  public shipment: OverdueDeliveryShipment;
  public products: number;
  public lines: any[];
  public remainedPallets: boolean;
  public sot: boolean;
  public sotPeriodicity: number;
  public carrierAssigned: boolean;
  public indicator: OverdueDeliveryIndicator;

  public static fromDto(data: any): OverdueDelivery {
    if (!data) {
      return null;
    }

    const today = moment();
    const overdueDelivery = new OverdueDelivery();

    overdueDelivery.deliveryNumber       = data.delivery_number;
    overdueDelivery.carrier              = OverdueCarrier.fromDto(data.carrier);
    overdueDelivery.origin               = OverdueDeliveryLocation.fromDto(data.origin);
    overdueDelivery.destination          = OverdueDeliveryLocation.fromDto(data.destination);
    overdueDelivery.deliveryDate         = data.delivery_date ? moment(data.delivery_date) : null;
    overdueDelivery.deliveryOriginalDate = data.delivery_original_date ? moment(data.delivery_original_date) : null;
    overdueDelivery.deliveryPriority     = data.delivery_priority;
    overdueDelivery.deliveryDeadline     = data.delivery_deadline ? moment(data.delivery_deadline) : null;
    overdueDelivery.overdue              = overdueDelivery.deliveryDeadline && today.isAfter(overdueDelivery.deliveryDeadline, 'day') ?
                                            today.diff(overdueDelivery.deliveryDeadline, 'day') + ' d' : null;
    overdueDelivery.deliveryGiDate       = data.delivery_gi_date ? moment(data.delivery_gi_date) : null;
    overdueDelivery.shipment             = OverdueDeliveryShipment.fromDto(data.shipment);
    overdueDelivery.picked               = data.picked;
    overdueDelivery.lines                = data.lines ? data.lines.map(l => OverdueDeliveryLine.fromDto(l)) : [];
    overdueDelivery.products             = overdueDelivery.lines.reduce((a, b) => a + b.quantity, 0);
    overdueDelivery.remainedPallets      = data.remained_pallets_at_retailer;
    overdueDelivery.sot                  = data.sot;
    overdueDelivery.sotPeriodicity       = data.sot_periodicity;
    overdueDelivery.carrierAssigned      = data.carrier_assigned;
    overdueDelivery.indicator            = data.indicator;

    if (overdueDelivery.overdue && !data.picked) {
      overdueDelivery.type = OverdueType.OVERDUE_NOT_PROCESSED;
    } else if (overdueDelivery.overdue && data.picked) {
      overdueDelivery.type = OverdueType.OVERDUE_PICKED;
    } else if (overdueDelivery.deliveryDeadline.isSame(today, 'day')) {
      overdueDelivery.type = OverdueType.DUE_TODAY;
    } else {
      overdueDelivery.type = OverdueType.NOT_OVERDUE;
    } if (data.blocked) {
      overdueDelivery.type = OverdueType.BLOCKED;
    }

    return overdueDelivery;
  }
}

export class OverdueCarrier {

  public name: string;
  public scacCode: string;
  public vendorNumber: string;

  public static fromDto(data: any): OverdueCarrier {
    if (!data) {
      return null;
    }

    const carrier = new OverdueCarrier();

    carrier.name         = data.name;
    carrier.scacCode     = data.scac_code;
    carrier.vendorNumber = data.vendor_number;

    return carrier;
  }
}

export class OverdueDeliveryLocation {

  public name: string;
  public glid: string;
  public locationType: LocalLocationType;
  public address: CmblAddress;

  public static fromDto(data: any): OverdueDeliveryLocation {
    if (!data) {
      return null;
    }

    const location = new OverdueDeliveryLocation();

    location.name         = data.name;
    location.glid         = data.glid;
    location.locationType = data.location_type;
    location.address      = data.address;

    return location;
  }
}

export class OverdueDeliveryLine {

  public line: number;
  public quantity: number;
  public productCode: string;
  public productDescription: string;

  public static fromDto(data: any): OverdueDeliveryLine {
    if (!data) {
      return null;
    }

    const line = new OverdueDeliveryLine();

    line.line               = data.line;
    line.quantity           = data.quantity;
    line.productCode        = data.product_code;
    line.productDescription = data.product_description;

    return line;
  }
}

export class OverdueDeliveryShipment {

  public loadNumber: number;

  public static fromDto(data: any): OverdueDeliveryShipment {
    if (!data) {
      return null;
    }

    const shipment = new OverdueDeliveryShipment();

    shipment.loadNumber = data.load_number;

    return shipment;
  }
}

export enum OverdueCollectionProductType {
  AU = 'AU',
  CC = 'CC',
  PA = 'PA',
  ALL = 'ALL'
}

export enum OverdueCollectionType {
  NATIONAL = 'NATIONAL',
  INTERNATIONAL = 'INTERNATIONAL',
  BOTH = 'BOTH'
}

export enum OverdueDeliveryIndicator {
  WARNING = 'WARNING',
  HOURGLASS = 'HOURGLASS',
  CHECK = 'CHECK',
  CROSS = 'CROSS',
  NONE = 'NONE',
}
